import { useHRRContext } from '../../context'
import { Warnings as W } from '../BankAccounts/components'

export const Warnings = () => {
  const { data } = useHRRContext()
  const { showInfoWarnings } = data

  if (!showInfoWarnings) {
    return null
  }

  return (
    <div style={{ padding: '10px 50px' }}>
      <W warnings={showInfoWarnings} />
    </div>
  )
}
